import { TeamState } from "../types";

const state: TeamState = {
  currentMember: {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    role: 0,
  },
  members: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  pendingMembers: [],
  superAdminCount: 0,
  currentPendingMember: {
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    role: 0,
    expired: false,
  },
  inviteSender: {
    disabled: false,
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    role: 0,
  },
};

export default state;
